import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../shared/utils-service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  loggedInUser: any = {};
  menu: any ={};
  private showLeftMenu:boolean;
  constructor(private utils: UtilsService) {
    this.loggedInUser = this.utils._checkSession();
    let home={"router":"home", "menuName":"Home", "menuOrder":"0"};
      this.menu=this.loggedInUser.listGroupMenus;
      if(this.loggedInUser.listGroupMenus.length==5){
      this.menu.unshift(home);
      }
      this.showMenu();//DDMF-101

  }

  ngOnInit() {
  }

	expandMenu()
	{
		//console.log('in expand menu');
		
		if(document.getElementById("submenu").style.display === "block")
      	{
          document.getElementById("submenu").style.display = "none";
      	}
      else {
        document.getElementById("submenu").style.display = "block";
      }
  }
  
  //DDMF-101 Start
  showMenu(){  
    let user = sessionStorage.getItem('logged_in_user');
    let jsonData = JSON.parse(user);
    return this.showLeftMenu =jsonData.firstTimeLoginInd=='Y'?  true :  false;
  }
  //DDMF-101 End
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts